import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import Table from 'react-bootstrap/Table';
import { useNavigate, useParams, useLocation  } from "react-router-dom";
import { TiEdit,TiDeleteOutline, TiEyeOutline, TiTimes, TiTick } from "react-icons/ti";
import { FcPlus } from "react-icons/fc";
import { Container, Row, Col, Button, Stack } from 'react-bootstrap';
import { AgGridColumn, AgGridReact } from 'ag-grid-react';
import moment from "moment";
import { toast } from "react-toastify";

import { useAuthContext } from "../../contexts/AuthContext";
import UserDataService from "../../services/user.service";
// import ReactTooltip from "react-tooltip";
// import { TiEdit, TiDeleteOutline, TiEyeOutline } from "react-icons/ti";

import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-balham.css';
import "./User.scss";

const perPage = 10;

function Users() {

  const aggridRef = useRef();

  const navigate = useNavigate();
  const { user, setIsLoading } = useAuthContext();

  const [userList, setUserList] = useState([]);
  const [pageSize, setPageSize] = useState();

  useEffect(() => {
    if(user){
      retrieveSupplierDetails();
    }
  }, [user])
  

  function retrieveSupplierDetails() {
    setIsLoading(true);
    UserDataService.getByProjectAssociation().then((response) => {
      setUserList(response.data.data);
      setIsLoading(false);
    });
  }

  function deleteSupplier(id) {
    setIsLoading(true);
    UserDataService.delete(id).then((response) => {
      if(response.data.success){
        const updatedSupplier = userList.filter((item) => item.id !== id);
        setUserList(updatedSupplier);
        setIsLoading(false);
        toast.error("Supplier Deleted!");
      } else {
        setIsLoading(false);
        toast.error("Error in deleting supplier");
      }
    });
  }

  function onPageSizeChanged(e) {
    let value = e.target.value;
    setPageSize(value);
    aggridRef.current.api.paginationSetPageSize(Number(value));
  };

  const columnDefs = [
    {headerName: "User Name", field: "name", filter: true, sortable:true, unSortIcon:true },
    {headerName: "Email", field: "email",filter: true, sortable:true, unSortIcon:true},
    {headerName: "Role", field: "role",filter: true, sortable:true, unSortIcon:true},
    // {headerName: "SSO User", field: "ssoUser",filter: true, sortable:true, unSortIcon:true, width:"150",
    //   cellRendererFramework: (data) => {
    //     return (data.value ? <span className="text-primary"><TiTick size={18} /></span> :  <span className="text-warning"><TiTimes size={18} /></span>)
    //   } 
    // },
    {headerName: "Active", field: "active",filter: true, sortable:true, unSortIcon:true, width:"150",
      cellRendererFramework: (data) => {
        return (data.value ? <span className="text-primary"><TiTick size={18} /></span> :  <span className="text-warning"><TiTimes size={18} /></span>)
      } 
    },
    // {headerName: "updatedAt", field: "updatedAt",filter: true,  sortable:true, width:"160",
    //     cellRendererFramework: (data) => {
    //       return moment(new Date(data.value)).format("DD/MM/yyyy hh:mm:ss A")
    //     } 
    // },
    {headerName: "action", field:"id", 
        cellRendererFramework: (data) => {
            return <>
                  <Link title="Details" className="text-primary mr-2 margin-right" to={"/users/"+data.value+"/detail"}><TiEyeOutline  size="25" /></Link>
                  {user && user?.role === "admin"
                    ? user._id === data.data._id
                    ? <Link title="Edit" className="text-success mr-2 margin-right" to={"/users/"+data.value+"/edit"}><TiEdit  size="25" /></Link>
                    : <></>
                    : <Link title="Edit" className="text-success mr-2 margin-right" to={"/users/"+data.value+"/edit"}><TiEdit  size="25" /></Link>
                  }
                  {user && user?.role === "superadmin" && (
                    <span className="text-danger cursor-pointer" title="delete" onClick={() => this.deleteUser(data.value)}><TiDeleteOutline size="25" /></span>
                  )}
                </>
       }
    }
  ]

  return (
    <Container fluid="md">
      <Row>
        <Col sm={8}><h1 className="mt-4 pageTitle">Users List</h1></Col>
        <Col sm={4}>
          <Stack direction="horizontal" gap={1}>
            <Button variant="primary" className="mt-4" onClick={() => navigate(`/users/create`)}><FcPlus /> Create New User</Button>
          </Stack>
        </Col>
      </Row>
      <hr />
      <Row>
        <Col>
          <div className="ag-theme-balham" style={{height: '567px', width: '100%'}} >
            {userList && userList.length > 0 ? (
              <div className="example-header">
                Page Size: &nbsp;
                <select onChange={onPageSizeChanged} id="page-size" value={pageSize}>
                  <option value="10">
                    10
                  </option>
                  <option value="100">100</option>
                  <option value="500">500</option>
                  <option value="1000">1000</option>
                </select>
              </div>
            ) : (
              <h6>No User Found</h6>
            )}
            {userList && userList.length > 0 && (
              <AgGridReact
                  ref={aggridRef}
                  pagination={true}
                  rowHeight={50}
                  paginationPageSize={perPage}
                  columnDefs={columnDefs}
                  rowData={userList}>
              </AgGridReact>
            )}
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default Users;
